import { render, staticRenderFns } from "./wps.vue?vue&type=template&id=1a367b3d"
import script from "./wps.vue?vue&type=script&lang=js"
export * from "./wps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports